import NewEstimatePage from "@/components/screens/estimate/new";

export default function NewEstimate() {
  return <NewEstimatePage />;
}
